import React from 'react'
import './style.scss'


import DsnGrid from "../DsnGrid";
import type {DsnGridProps} from "../DsnGrid";
import {dsnCN} from "../../hooks/helper";

const ServicesDetails = [
  {
    title: "Music",
    description: `Fantasy-inspired instrumentals and melodies crafted for adventure and exploration. Each piece is a small world waiting to be heard.`
  },
  {
    title: "Meditation",
    description: `Guided meditation and breathwork sessions enriched with immersive soundscapes. These creations guide the mind on journeys inward.`
  },
  {
    title: "Videos",
    description: `Visual stories and cinematic moments that bring music and fantasy worlds to life. Each video is a portal into imagination and discovery.`
  },
  {
    title: "Art",
    description: `Drawings, sketches, and concept art inspired by folklore and fantasy. Each creation opens a doorway to a miniature world of wonder.`
  },
  {
    title: "Podcasts",
    description: `Narrative and discussion podcasts blending music, story, and reflection. These productions offer companions for thought, adventure, and imagination.`
  },
  {
    title: "Code",
    description: `Websites and digital tools designed to turn ideas into interactive experiences. Each project is a crafted space to explore.`
  }
]

const ServiceTow = ({className, ...restProps}: DsnGridProps) => {
    return (
        <DsnGrid className={dsnCN('dsn-services service-tow', className)} {...restProps}>
            {ServicesDetails.map(
                (item, index) =>
                    <div className='service-item' key={index}>
                        <div className="line-before mb-20"/>
                        <h4 className='title-block'>{item.title}</h4>
                        <p className='mt-15 dsn-auto'>{item.description}</p>
                    </div>
            )}

        </DsnGrid>
    );
};


export default ServiceTow